// 校验ATCG允许输入[]/
export const regATCG = /^[ATCGatcgａｔｃｇＡＴＣＧ\[\]\/]*$/
// 仅允许输入ATCG
export const regOnlyATCG = /^[ATCGatcgａｔｃｇＡＴＣＧ]*$/


// WEBPACK FOOTER //
// ./src/utils/regexp.js